import {
  Button,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import theme from "../../theme";
import useButtonStyles from "../../styles/useButtonStyles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Link, useParams } from "react-router-dom";
import SelectInputField from "../forms/formElements/SelectInputField";
import axios from "axios";
import { APIConstants } from "../../constants/ApiConstants";
import BasicModal from "../ui/BasicModal";
import Loader from "../ui/Loader";
import BasicAutoComplete from "../ui/BasicAutoComplete";
import { useAppSelector } from "../../redux/hooks";
import CloseIcon from "@mui/icons-material/Close";
import {
  filterConstants,
  mobileConstraints,
} from "../../constants/AppConstants";
import useActiveMerchants from "../../Hooks/merchant/useActiveMerchants";
export interface IAppProps {
  closeDrawer?: Function;
  onRefresh?: () => void;
}
const AddShopUserForm = (props: IAppProps) => {
  const { closeDrawer, onRefresh } = props;
  const [statusState, setStatusState] = useState({ status: "" });
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [apiSuccess, setApiSuccess] = useState(false);
  const [apiFailure, setApiFailure] = useState("Something Went Wrong");

  const [merchantRoles, setMerchantRoles] = useState<string[]>([]);

  const [successMessageForAddUser, setSuccessMessageForAddUser] = useState("");
  const params = useParams();
  const { merchantId } = params;
  const entireList = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList.entireListOfMerchants
  );
  const filterMerchantList = useActiveMerchants();

  const merchantListFromRedux = entireList?.map((entity: any) => {
    return {
      id: entity.id,
      label: entity.name,
      external_id: entity.external_id,
    };
  });
  const selectedMerchant = merchantListFromRedux?.find(
    (ele: any) => ele.id === merchantId
  )?.label;

  const [validationState, setValidationState] = useState({
    email: "",
  });
  const buttonStyles = useButtonStyles();

  const [formState, setFormState] = useState({
    email: "",
    first_name: "",
    last_name: "",
    mobile: "",
    merchant: selectedMerchant,
    user_role: "",
  });
  const [visited, setVisited] = useState({
    email: false,
    first_name: false,
    last_name: false,
    mobile: false,
    merchant: false,
    status: false,
    user_role: false,
  });

  useEffect(() => {
    if (!openModal) onRefresh && onRefresh();
  }, [openModal]);

  const addShopUser = async () => {
    try {
      setLoading(true);
      const external_id = merchantListFromRedux?.find(
        (ele: any) => ele.label === selectedMerchant
      )?.external_id;
      const entry = entireList.find(
        (entry: any) => entry.name === selectedMerchant
      );
      const companyName = entry.custom_fields.field.find(
        (field: any) => field.name === "companyName"
      )?.value;

      const response = await axios.post(
        process.env.REACT_APP_API_URL + APIConstants.addShopUser,
        {
          ...formState,
          ...statusState,
          external_id,
          companyName,
          module: "merchant",
          feature: "shop_user",
        }
      );
      setApiSuccess(true);
      setOpenModal(true);
      setSuccessMessageForAddUser(response.data);
    } catch (error: any) {
      if (error?.response?.data?.message) {
        setApiFailure(error?.response?.data?.message);
      }
      console.error(error);
      setApiSuccess(false);
      setOpenModal(true);
    } finally {
      setLoading(false);
    }
  };

  const formValidate = () => {
    if (formState.first_name === "") return false;
    if (formState.last_name === "") return false;
    if (formState.email === "" || validationState.email !== "") return false;

    if (
      statusState.status === "" ||
      statusState.status === filterConstants.Select
    )
      return false;

    return true;
  };

  useEffect(() => {
    const fetchRoleList = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          process.env.REACT_APP_API_URL + APIConstants.role + "?type=Merchant"
        );
        const data = response.data.data;
        const roles = data.map((item: any) => {
          return item.name;
        });
        setMerchantRoles(roles);
        setLoading(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    };

    fetchRoleList();
  }, []);
  return (
    <Grid display={"flex"} flexDirection={"column"} height={"100%"}>
      <Grid
        item
        width={"100%"}
        height={"6.25rem"}
        display={"flex"}
        alignItems={"center"}
        sx={{ background: theme.color?.background }}
      >
        <Grid
          item
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
          px={4}
          gap={2}
          width={"100%"}
        >
          <Typography
            variant="h6"
            sx={{
              fontFamily: theme.font?.fontFamily.primary,
              fontSize: theme.font?.fontSize.large,
              fontWeight: theme.font?.fontWeight.thick,
            }}
            pl={2}
          >
            Add Shop User
          </Typography>
          <IconButton
            aria-label="delete"
            onClick={closeDrawer ? () => closeDrawer(false) : () => {}}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: theme?.color?.background,
        }}
        width={"100%"}
        height={"100%"}
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"space-between"}
      >
        <Grid pt={2} px={4} display={"flex"} flexDirection={"column"} gap={2}>
          <Grid display={"flex"} gap={2} width={"100%"}>
            <Grid item width={"50%"}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                First Name *
              </Typography>
              <TextField
                type="text"
                fullWidth
                size="small"
                value={formState.first_name}
                onFocus={(e) =>
                  setVisited((prev) => ({
                    ...prev,
                    first_name: true,
                  }))
                }
                onChange={(e) =>
                  setFormState((prev) => ({
                    ...prev,
                    first_name: e.target.value,
                  }))
                }
                error={visited.first_name && formState.first_name === ""}
                helperText={
                  visited.first_name && formState.first_name === ""
                    ? "Required field"
                    : ""
                }
              ></TextField>
            </Grid>
            <Grid item width={"50%"}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                Last Name *
              </Typography>
              <TextField
                type="text"
                fullWidth
                size="small"
                value={formState.last_name}
                onFocus={(e) =>
                  setVisited((prev) => ({
                    ...prev,
                    last_name: true,
                  }))
                }
                onChange={(e) =>
                  setFormState((prev) => ({
                    ...prev,
                    last_name: e.target.value,
                  }))
                }
                error={visited.last_name && formState.last_name === ""}
                helperText={
                  visited.last_name && formState.last_name === ""
                    ? "Required field"
                    : ""
                }
              ></TextField>
            </Grid>
          </Grid>
          <Grid display={"flex"} gap={2} width={"100%"}>
            <Grid item width={"50%"}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                Email *
              </Typography>
              <TextField
                fullWidth
                type="email"
                size="small"
                value={formState.email}
                onFocus={(e) =>
                  setVisited((prev) => ({
                    ...prev,
                    email: true,
                  }))
                }
                onChange={(e) => {
                  const email = e.target.value;
                  setFormState((prev) => ({ ...prev, email }));
                  // Email validation using regex
                  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
                  const isValidEmail = emailRegex.test(email);
                  setValidationState((prev) => ({
                    ...prev,
                    email: !isValidEmail ? "Invalid email address" : "",
                  }));
                }}
                error={
                  visited.email &&
                  (validationState.email !== "" || formState.email === "")
                }
                helperText={
                  visited.email && validationState.email !== ""
                    ? "Invalid email address"
                    : ""
                }
              ></TextField>
            </Grid>
            <Grid item width={"50%"}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                Mobile Number
              </Typography>
              <TextField
                type="number"
                fullWidth
                size="small"
                value={formState.mobile}
                error={
                  visited.mobile &&
                  (formState.mobile === "" ||
                    formState.mobile.length < mobileConstraints.mobileMin ||
                    formState.mobile.length > mobileConstraints.mobileMax)
                }
                helperText={
                  visited.mobile &&
                  (formState.mobile.length < mobileConstraints.mobileMin ||
                    formState.mobile.length > mobileConstraints.mobileMax)
                    ? "Invalid Number"
                    : ""
                }
                onFocus={(e) =>
                  setVisited((prev) => ({
                    ...prev,
                    mobile: true,
                  }))
                }
                onChange={(e) =>
                  setFormState((prev) => ({ ...prev, mobile: e.target.value }))
                }
              ></TextField>
            </Grid>
          </Grid>

          <Grid display={"flex"} gap={2} width={"100%"}>
            <Grid item width={"50%"}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                Merchant *
              </Typography>
              <TextField
                sx={{
                  backgroundColor: theme.color?.greyBackground,
                }}
                type="text"
                fullWidth
                size="small"
                InputProps={{ readOnly: true }}
                value={formState.merchant}
              ></TextField>
            </Grid>
            <Grid item width={"50%"}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                Role *
              </Typography>
              <SelectInputField
                sx={{ width: "100%" }}
                setState={setFormState}
                stateKey="user_role"
                defaultValue="Tenant Admin"
                align="left"
                options={merchantRoles}
              />
            </Grid>
          </Grid>
          <Grid display={"flex"} gap={2} width={"100%"}>
            <Grid item width={"50%"}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                Status *
              </Typography>
              <SelectInputField
                sx={{ width: "100%" }}
                setState={setStatusState}
                stateKey="status"
                defaultValue={filterConstants.Select}
                align="left"
                options={[
                  filterConstants.Select,
                  filterConstants.Active,
                  filterConstants.Inactive,
                ]}
                error={
                  visited.status &&
                  (statusState?.status === "" ||
                    statusState?.status === filterConstants.Select)
                }
                onFocus={(e) =>
                  setVisited((prev) => ({
                    ...prev,
                    status: true,
                  }))
                }
              />
            </Grid>
            <Grid item width={"50%"}>
              <Typography sx={{ fontFamily: theme.font?.fontFamily.primary }}>
                Designation
              </Typography>
              <TextField type="text" fullWidth size="small"></TextField>
            </Grid>
          </Grid>
          <Grid display={"flex"} gap={2}></Grid>
        </Grid>

        <Grid
          container
          item
          marginTop={4}
          justifyContent={"center"}
          borderTop={`${theme?.border?.xsmall}${theme.color?.dividerLight}`}
          padding={2}
          pt={3}
          pb={4}
          display={"flex"}
          gap={2}
        >
          <Button
            sx={{ ...buttonStyles.outlinedSecondary, width: "45%" }}
            variant="outlined"
            onClick={closeDrawer ? () => closeDrawer(false) : () => {}}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            sx={{ ...buttonStyles.containedSecondary, width: "45%" }}
            variant="contained"
            onClick={addShopUser}
            disabled={!formValidate()}
          >
            Save
          </Button>
        </Grid>
        {openModal && (
          <BasicModal
            title={apiSuccess ? successMessageForAddUser : apiFailure}
            setState={setOpenModal}
            success={apiSuccess}
            onCloseModule={closeDrawer ? () => closeDrawer(false) : () => {}}
          />
        )}
        {loading && <BasicModal content={<Loader />} />}
      </Grid>
    </Grid>
  );
};

export default AddShopUserForm;
